// extracted by mini-css-extract-plugin
module.exports = {"root":"SignOff_root__kU9Ge","topBorder":"SignOff_topBorder__d4HMx","title":"SignOff_title__CDfeQ","text":"SignOff_text__jOd8h"};